<div class="timeline-home-container">
  <div *ngFor="let day of timeline; trackBy: trackByIndex">
    <app-timeline-detail-day [day]="day" [isChaseTimeline]="isChaseTimeline"></app-timeline-detail-day>
  </div>
</div>
